import $api from '../http';
import { AxiosResponse } from 'axios';
import { AuthResponse } from '../models/response/AuthResponse';

export default class AuthService {
  static async login(email: string, password: string): Promise<AxiosResponse<AuthResponse>> {
    try {
      const response: AxiosResponse<AuthResponse> = await $api.post<AuthResponse>('/user/login', { email, password });
      return response;
    } catch (error) {
      // Handle any errors that might occur during the API call
      console.error('Error occurred during login:', error);
      throw error; // Rethrow the error to be caught by the caller, if necessary
    }
  }

  static async registration(email: string, password: string): Promise<AxiosResponse<AuthResponse>> {
    return $api.post<AuthResponse>('/user/register', { email, password })
  }

  static async logout(): Promise<void> {
    return $api.post('/user/logout')
  }
}
